<template>
    <div>
        <div v-if="editing"
             class="w-100">
            <b-form-input
                ref="input"
                v-model="localValue"
                class="input-auto"
                autofocus
                debounce="500"
                @focus.native="whenFocus"
                @blur="whenBlur"
                @keydown.enter="whenBlur">
            </b-form-input>
        </div>
        <template v-else>
            <b-badge variant="light" class="badge-text"
                     @click="editing=true">
                {{ hasCode(localValue) ? valueLabel + localValue : defaultValue }}
            </b-badge>
        </template>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ClickEdit",
    mixins: [emCommonUtilMixin],
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: null,
        valueLabel: {
            type: String,
            default: ''
        },
        defaultValue: String,
    },
    data() {
        return {
            editing: false,
            localValue: this.value,
        }
    },
    watch: {
        localValue() {
            this.$emit('update:value', this.localValue);
            this.$emit('change', this.localValue);
        },
        value: {
            handler() {
                this.localValue = this.value;
            },
            immediate: true
        },
    },
    methods: {
        whenBlur() {
            this.editing = false;
            this.$emit('inputBlur');
        },
        whenFocus() {
            if (!this.hasCode(this.localValue) && this.hasCode(this.defaultValue)) {
                this.localValue = this.defaultValue;
                this.$refs.input.select();
            }
        },
    }
}
</script>

<style scoped>
.badge-text {
    font-size: .8rem;
    padding: .5rem;
}

.input-auto {
    width: max-content !important;
}
</style>
